import { css } from 'styled-components';
import { cssVar, setCssVar } from './cssVar';
import { Device, from } from './media';
export const SitePadding = 18;
export const SiteWidth = 1604;
export const SiteWidthBreakpoint = SiteWidth + SitePadding * 2;
export const siteWide = css `
  ${setCssVar('sitePadding', `${SitePadding}px`)};
  ${setCssVar('siteWidth', `${SiteWidth}px`)};

  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: min(
    calc(${cssVar('siteWidth')} + ${cssVar('sitePadding')} + ${cssVar('sitePadding')}),
    100vw
  );
  padding: 0 ${cssVar('sitePadding')};
  width: 100%;
`;
export const baseGrid = css `
  ${setCssVar('gutterWidth', '10px')};

  display: grid;
  column-gap: ${cssVar('gutterWidth')};
  grid-template-columns: repeat(12, 1fr);

  @media ${from(Device.Tablet)} {
    ${setCssVar('gutterWidth', '32px')};
  }

  @media ${from(Device.DesktopLarge)} {
    ${setCssVar('gutterWidth', '64px')};
  }
`;
